// The processor's shared data, where parser plugins collect their micromark extensions.
interface ParserData {
  micromarkExtensions?: unknown[];
}

// A unified plugin; `this` is the processor it is attached to.
export function disableIndentedCode(this: { data(): object }) {
  const data = this.data() as ParserData;
  const micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);

  micromarkExtensions.push({
    disable: { null: ['codeIndented'] },
  });
}
